import React, { useState } from 'react';
import { Confirmation } from '@otp/ui';
import { Button } from '@otp/ui';
import { useMarkAllAsRead } from 'src/hooks/query/notification/use-mark-all-as-read';
import { useTranslation } from 'react-i18next';
import { Alert, Flag } from '@otp/icons';
import { DocumentNode } from 'graphql';

export const MarkAllUnreadButton = ({
  refetchDocuments,
}: {
  refetchDocuments: DocumentNode[];
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [markAsReadMutation] = useMarkAllAsRead(refetchDocuments);

  const onMarkAsRead = () => {
    markAsReadMutation();
    setShowModal(false);
  };

  return (
    <>
      <Button
        variant="contained"
        className=""
        onClick={() => setShowModal(true)}
      >
        <Flag />
        {t('notifications.list.mark-all-as-read-button')}
      </Button>

      {showModal && (
        <Confirmation
          open={showModal}
          title={
            <div className="flex gap-1">
              <Alert /> {t('notifications.list.mark-all-as-read-confirmation')}
            </div>
          }
          message={t('notifications.list.confirm-mark-as-read')}
          onClose={() => setShowModal(false)}
          onConfirm={onMarkAsRead}
        />
      )}
    </>
  );
};
